<template>
    <div class="dispatch-center">
        <div class="po-center">
            <!-- <TopTitle class="mt-150"/> -->
            <!-- <div v-for="(item, i) in dataList"
                :key="'dataList' + i"
                class="c-item"
                :class="[`item-${i+1}`, {'center': item.center}]">
                <img class="img" :src="item.pic" alt="">
                <dv-border-box-1 />
                <div class="item-t" :class="{'center': item.center}">{{ item.title }}</div>
                <div class="item-icon" :class="{'center': item.center}">
                    <div v-if="item.center" class="icon-circle"></div>
                </div>
            </div> -->
            <div class="computilityMap mt-200">
                <!-- <div class="item-1 mark">
                    <div class="orangeBg imgTitle1 TitleSize">
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;北京智算中心(运营中)</p>
                        <p>总算力XXXP</p>
                    </div>
                    <div class="base-1">
                        <img class="img" :src="require(`@/assets/images/computility/orangeDrill.png`)" alt="">
                        <div class="base-img"></div>
                    </div>
                </div>
                <div class="item-2 mark">
                    <div class="yellowBg imgTitle TitleSize">
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;北京智算中心(建设中)</span>
                    </div>
                    <div class="base-2">
                        <img class="img c-img" :src="require(`@/assets/images/computility/yellowDrill.png`)" alt="">
                    </div>
                </div>
                <div class="item-3 mark">
                    <div class="yellowBg imgTitle TitleSize">
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;XX智算中心(建设中)</span>
                    </div>
                    <div class="base-2">
                        <img class="img c-img" :src="require(`@/assets/images/computility/yellowDrill.png`)" alt="">
                    </div>
                </div>
                <div class="item-4 mark">
                    <div class="blueBg imgTitle TitleSize">
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;XX智算中心(规划中)</span>
                    </div>
                    <div class="base-3">
                        <img class="img c-img" :src="require(`@/assets/images/computility/blueDrill.png`)" alt="">
                    </div>
                </div> -->
                
                <orange  style="position: absolute;top:700px;left:1120px;" :isShow="index == 1 || index == 3 ? true : false" number="374" number1="499" z_index="10"/>
                <yellow1 v-show="index == 2 || index == 3" style="position: absolute;top:450px;left:980px;" title="北京丰台智算中心(筹建中)" number="250"/>
                <yellow2 v-show="index == 2 || index == 3" style="position: absolute;top:570px;left:880px;" title="咸阳智算中心(筹建中)" number="250"/>
                <yellow3 v-show="index == 2 || index == 3" style="position: absolute;top:780px;left:1140px;" title="丽水青田智算中心(筹建中)" number="453" z_index="10"/>
                <yellow4 v-show="index == 2 || index == 3" style="position: absolute;top:1050px;left:920px;" title="深圳宝安智算中心(筹建中)" number="125"/>
                <blue1 v-show="index == 3 || index == 3" style="position: absolute;top:613px;left:780px;" title="庆阳智算中心(规划中)" number="125"/>
                <blue2 v-show="index == 3 || index == 3" style="position: absolute;top:840px;left:780px;" title="重庆智算中心(规划中)" number="125" z_index="10"/>
                <blue3 v-show="index == 3 || index == 3" style="position: absolute;top:750px;left:1160px;" title="上海闵行智算中心(规划中)" title2="上海浦东临港智算中心(规划中)"  :isShow="true" z_index="10"/>
                <blue4 v-show="index == 3 || index == 3" style="position: absolute;top:773px;left:870px;" title="南京浦口智算中心(规划中)" :isShow="false"/>
                <blue5 v-show="index == 3 || index == 3" style="position: absolute;top:821px;left:1000px;" title="武汉武昌智算中心(规划中)" :isShow="false"/>
                <blue6 v-show="index == 3 || index == 3" style="position: absolute;top:820px;left:1160px;" title="浙江建德智算中心(规划中)" :isShow="false" z_index="10"/>
            </div>
        </div>
    </div>
</template>

<script>
import orange from './../../components/orange.vue'
import yellow1 from './../../components/yellow.vue'
import yellow2 from './../../components/yellow.vue'
import yellow3 from './../../components/yellow.vue'
import yellow4 from './../../components/yellow.vue'
import blue1 from './../../components/blue1.vue'
import blue2 from './../../components/blue1.vue'
import blue3 from './../../components/blue.vue'
import blue4 from './../../components/blue.vue'
import blue5 from './../../components/blue.vue'
import blue6 from './../../components/blue.vue'
import { set } from 'vue'
export default {
    components:{
        // TopTitle
        orange,
        yellow1,
        yellow2,
        yellow3,
        yellow4,
        blue1,
        blue2,
        blue3,
        blue4,
        blue5,
        blue6,
    },
    data() {
        return {
            dataList: [
                {
                    title: '协鑫智算中心',
                    pic: require('@/assets/images/computility/dispatch-p1.jpg'),
                    center: true
                },
                {
                    title: '零碳能源交通',
                    pic: require('@/assets/images/computility/dispatch-p2.jpg')
                },
                {
                    title: '数字工厂',
                    pic: require('@/assets/images/computility/dispatch-p3.jpg')
                },
                {
                    title: '虚拟电厂',
                    pic: require('@/assets/images/computility/dispatch-p4.jpg')
                }
            ],
            index: 0,
            timer:null,
        }
    },
    created(){
        this.getIndex()
    },
    watch: {
        index:function(newVal, oldVal){ 
            if(newVal >= 3){
                setTimeout(() =>{
                    this.index = 0
                    this.getIndex()
                },10000)
            }
        }
    },
    methods: {
        getIndex(){
            this.timer = setInterval(() => {
                this.index++
                if(this.index >= 3){
                    clearInterval( this.timer )
                    this.index = 3
                }
            },3000)
        }
    },
    destroyed () {
        console.log('beforeDestroy')
        clearInterval( this.timer )
    },
}
</script>

<style lang="scss" scoped>
@import '../../components/comm.scss';
.dispatch-center {
    width: 100%;
    height: 100%;
    // background: url(~@/assets/images/computility/dispatch-bg.jpg) no-repeat;
    background: url(~@/assets/images/computility/overview-bg.png) no-repeat;
    background-size: 100% 100%;
    .po-center {
        // width: 1100px;
        // height: 1100%;
        width: 1701px;
        height: 90%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .c-item {
            width: 363px;
            height: 274px;
            position: absolute;
            &.center {
                width: 524px;
                height: 395px;
            }
            &.item-1 {
                top: 0;
                left: 50%;
                transform: translate(-40%, 0);
            }
            &.item-2 {
                top: 50px;
                right: -300px;
            }
            &.item-3 {
                bottom: 0;
                left: -200px;
            }
            &.item-4 {
                top: 0;
                left: -200px;
            }
            .img {
                width: 96%;
                height: 96%;
                position: absolute;
                border-radius: 20px;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            .item-t {
                position: absolute;
                // width: 192px;
                height: 50px;
                bottom: 6px;
                left: 50px;
                background-color: #fff;
                border-radius: 8px;
                box-shadow: 2px 2px 6px 0px #FFFDE9;
                color: #1955D9;
                font-weight: bold;
                font-size: $FontSize32;
                display: flex;
                align-items: center;
                padding: 0 30px;
                // justify-content: center;
                &.center {
                    left: 120px;
                    bottom: -70px;
                }
            }
            .item-icon {
                background: url(~@/assets/images/computility/dispatch-icon2.png) no-repeat;
                background-size: 100%;
                width: 154px;
                height: 150px;
                margin: 20px auto 0;
                &.center {
                    background: url(~@/assets/images/computility/dispatch-icon1.png) no-repeat;
                    background-size: 100%;
                    width: 357px;
                    height: 344px;
                    margin: 100px auto 0;
                    position: relative;
                }
                .icon-circle {
                    background: url(~@/assets/images/computility/dispatch-icon3.png) no-repeat;
                    background-size: 100%;
                    width: 500px;
                    height: 238px;
                    position: absolute;
                    top: 72%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    animation: diffuse 2s ease infinite;
                }
            }
        }
        .computilityMap{
            position: absolute;
            top: 0;
            left: 0;
            width: 1812px;
            height: 1701px;
            background: url(~@/assets/images/computility/computilityMap.png) no-repeat;
            background-size: 100% 100%;
            .item-1{
                position: absolute;
                top: 550px;
                right: 280px;
                z-index: 10;
            }
            .item-2{
                position: absolute;
                top: 480px;
                right: 300px;
            }
            .item-3{
                position: absolute;
                top: 720px;
                left: 580px;
            }
            .item-4{
                position: absolute;
                top: 520px;
                left: 200px;
            }
            .mark{
                width: 450px;
                height: 200px;
                display: flex;
                flex-direction: column;
                align-items: center;
                img{
                    animation: Beating 1.2s ease infinite;
                }

                .base-2,.base-3{
                    .c-img{
                        position: absolute;
                        top: 0;
                        left: 30px;
                    }
                }
                .base-2{
                    position: absolute;
                    top: 60px;
                    left: 140px;
                    width: 150px;
                    height: 150px;
                    background: url(~@/assets/images/computility/yellowBase.png) no-repeat;
                    background-size: 80% 80%;
                }
                .base-3{
                    position: absolute;
                    top: 60px;
                    left: 140px;
                    width: 150px;
                    height: 150px;
                    background: url(~@/assets/images/computility/blueBase.png) no-repeat;
                    background-size: 80% 80%;
                }
                .imgTitle{
                    width: 320px;
                    height: 50px;
                }
                .imgTitle1{
                    width: 320px;
                    height: 80px;
                }
                .TitleSize{
                    font-size: $FontSize28;
                }
                .orangeBg{
                    position: absolute;
                    top: -30px;
                    background: url(~@/assets/images/computility/operation-bg.png) no-repeat;
                    background-size: 100% 100%;
                }
                .yellowBg{
                    background: url(~@/assets/images/computility/construction-bg.png) no-repeat;
                    background-size: 100% 100%;
                }
                .blueBg{
                    background: url(~@/assets/images/computility/planning-bg.png) no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }
}




</style>